import { useLanguageContext } from "../../../../../context/LanguageContext";
import LabelItemParagraph from "../paragraph/ParagraphLabelItem";

export default function TextLabelItem({ item, printerData }) {
  const { translateEntity } = useLanguageContext();

  return (
    <LabelItemParagraph item={item} printerData={printerData}>
      {translateEntity(item, "text")}
    </LabelItemParagraph>
  );
}
